import { useState, useEffect } from 'react';

/**
 * Custom hook for hash-based navigation
 * Manages active view and syncs with URL hash
 */
export function useNavigation() {
  // Helper function to get view from hash
  const getViewFromHash = () => {
    const hash = window.location.hash.slice(1); // Remove #
    const validViews = ['dashboard', 'tasks', 'templates', 'locations', 'users'];
    return validViews.includes(hash) ? hash : 'dashboard';
  };

  // Initialize activeView from URL hash
  const [activeView, setActiveView] = useState(getViewFromHash);

  // Set default hash if none exists on initial load
  useEffect(() => {
    if (!window.location.hash) {
      window.history.replaceState(null, '', '#dashboard');
    }
  }, []);

  // Listen to hash changes (browser back/forward)
  useEffect(() => {
    const handleHashChange = () => {
      setActiveView(getViewFromHash());
    };

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return { activeView };
}
